import React from 'react'
import TemplateList from '../common/TemplateList'
import ClinicCallTemplate from './ClinicCallTemplate'

function TelephoneDashboard() {
  return (
    <div className="container container-xxl">
    <div className="row">
        <div className="col-6">
          <TemplateList type="call"/>
        </div>
        <div className="col-6">
          <ClinicCallTemplate/>
        </div>
    </div>
  </div>
  )
}

export default TelephoneDashboard